import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M3.723 10a6.278 6.278 0 1 0 12.555 0 6.278 6.278 0 0 0-12.555 0M10 2.223a7.778 7.778 0 1 0 0 15.555 7.778 7.778 0 0 0 0-15.555"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCircle;
